import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

export default function FloatingActionButton({toggleDrawer}) {
  return (
        <Fab size="small" color="primary" aria-label="add"
            sx={{
                position: "fixed",
                bottom: 24,
                right: 24,
                zIndex: 1000,
                backgroundColor: "rgba(0, 150, 136, 0.5)" // teal with 0.5 opacity
            }}
            onClick={toggleDrawer(true)}
        >
             <MenuIcon  />
        </Fab>
    )
}
